<template>
  <div>
    <div class="mt-4">
      <span class="titlemenu mt-4"> <slot name="title">空</slot></span
      ><span class="title-append">
        <slot name="append">空</slot>
      </span>
    </div>

    <div class="classManger">
      <rich-text
        @getcode="getcode"
        :id="'id' + Date.now() + ''"
        :ids="Date.now()"
        :value="value.content"
      ></rich-text>
    </div>
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";

import ue2 from "@/components/common/UE2.vue";
import RichText from "./RichText.vue";

export default {
  components: { ue2, RichText },
  props: {
    value: {
      type: Object,
      default: {
        content: "",
      },
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      /* dataObj: {
        list: [
          { id: 1, value: 1, title: "报名条件", appendTitle: "" },
          {
            id: 2,
            value: 3,
            title: "报名时间",
            appendTitle: "通过这门考试的科目，科目可以拖动排序",
          },
          {
            id: 3,
            value: 3,
            title: "报名流程",
            appendTitle: "报名流程尽可能用图表示，每一步如何操作",
          },
        ],
      }, */
      /*  rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur",
          },
        ],
      }, */
    };
  },
  methods: {
    getcode(content) {
      console.log("kaishi");
      this.$emit("changeText", {
        title: this.title,
        content: content,
        anotherContent: this.value.anotherContent || "",
      });
    },
    courseChange(courseObj, bol) {
      console.log("course传来的数据", courseObj);
      let id = courseObj.id;
      let index = this.dataObj.courseList.findIndex((obj) => obj.id === id);
      if (bol) {
        this.dataObj.courseList.splice(index, 1);
        return;
      }
    },
    //添加
    addCourse() {
      this.dataObj.courseList.push({ id: Date.now(), value: 1, title: "测试" });
    },
    //拖拽
    datadragEnd(list) {
      console.log(this.dataObj.courseList);
    },
    //生成二维码
    showQrcode(id, url) {
      this.qrImgDialog = true;
      this.$nextTick(() => {
        this.makeQrcode(id, url);
      });
    },
    makeQrcode(id, text) {
      console.log(text);
      document.getElementById(id).innerHTML = "";
      let qrcode = new QRCode(id, {
        width: 400,
        height: 400, // 高度
        text,
        correctLevel: QRCode.CorrectLevel.L,
      });
    },
  },
  watch: {},
  created() {
    /*  this.getCampusList();
    this.getPageList(); */
  },
  mounted() {
    /* window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}
/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateX(200px);
}
.titlemenu {
  font-weight: 600;
  font-size: 16px;
}
.title-append {
  display: inline-block;
  margin-left: 1rem;
  color: #a5a5a5;
}
.mt-4 {
  margin-top: 1rem;
}
.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/components/TextDes.vue